import React, { useEffect } from 'react';
import { useLocationQS } from '@src/utils/useLocationQS';
import { QsNames } from '@src/types/Browsing';
import { EPopup } from '@src/types/common';
import { setPopup } from '@src/state/popupAtoms';
import { Services } from '@src/types/Services';

interface Props {
  services: Services;
}

/**
 * This component detects when getRightsModal query string is present
 * and opens the popup accordingly. It doesn't render anything itself.
 */
export default function GetRightsQueryStringDetector(props: Props) {
  const {
    [QsNames.getRightsModal]: [mediaId],
  } = useLocationQS([QsNames.getRightsModal]);

  useEffect(() => {
    if (mediaId) {
      // Query string detected - open popup with mediaId
      setPopup(EPopup.getRights, { mediaId });
    } else {
      // No query string - close popup
      setPopup(EPopup.getRights, null);
    }
  }, [mediaId]);

  // This component doesn't render anything
  return null;
}
